import { render, staticRenderFns } from "./drawer-project-settings.vue?vue&type=template&id=7263783a&"
import script from "./drawer-project-settings.vue?vue&type=script&lang=js&"
export * from "./drawer-project-settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports